import React from "react";
import { useModal } from "../_contexts";
import { Icon, IconButton } from "./";

export function Modal(props) {
  const {
    backdrop = "static",
    open,
    onClose,
    children,
    title,
    icon,
    size,
    noPadding,
    fullSize,
    unclosable,
    unscrollable,
  } = props;

  const { closeModal } = useModal();
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      closeModal();
    }
  };

  let classes = ["chronos-modal-content"];
  if (size && size.length > 0) {
    classes.push(`chronos-modal-${size}`);
  }
  if (noPadding) {
    classes.push("chronos-modal-no-padding");
  }
  if (fullSize) {
    classes.push("chronos-modal-fullheight");
  }
  if (unscrollable) {
    classes.push("chronos-modal-noscroll");
  }

  return (
    <>
      {open && (
        <div className="chronos-modal">
          <ModalBackdrop backdropType={backdrop} close={handleClose} />
          <div className={classes.join(" ")}>
            <ModalHeader
              title={title}
              icon={icon}
              close={handleClose}
              unclosable={unclosable}
            />
            <div className="chronos-modal-body">{children}</div>
          </div>
        </div>
      )}
    </>
  );
}

function ModalBackdrop(props) {
  const { backdropType, close } = props;
  // console.log(typeof backdropType, backdropType);
  let classes = "chronos-modal-backdrop";
  if (typeof backdropType === "boolean" && backdropType === true) {
    classes += " chronos-modal-backdrop-default";
  } else if (backdropType === "static") {
    classes += " chronos-modal-backdrop-static";
  }
  return (
    <div
      className={classes}
      onClick={() =>
        backdropType && backdropType !== "static" && close ? close() : ""
      }
    ></div>
  );
}

function ModalHeader(props) {
  const { title, icon, close, unclosable } = props;
  return (
    <div className="chronos-modal-header">
      <h4 className="chronos-modal-title">
        {icon && <Icon icon={icon} />}
        {title}
      </h4>
      {!unclosable && (
        <IconButton
          icon="fas fa-times"
          onClick={close}
          iconColor="rgb(0,0,0,0.5)"
        />
      )}
    </div>
  );
}
